import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Check if an email address is registered
 * Used by guest checkout flow to determine if user needs to sign in or sign up
 */
export const checkEmailExistsRpcContract = rpcContract({
  name: "check-email-exists",
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.email()),
  }),
  resultSchema: v.object({
    exists: v.boolean(),
  }),
});

export type CheckEmailExistsParams = v.InferOutput<(typeof checkEmailExistsRpcContract)["paramsSchema"]>;
export type CheckEmailExistsResult = v.InferOutput<(typeof checkEmailExistsRpcContract)["resultSchema"]>;
